module.exports = __webpack_public_path__ + "img/confirm_order.299e30fa.svg";